export const REPORT_DESIGNER_ENGLISH = {
  "datox.designer.configurationPanel": "Widget configuration",
  "datox.designer.resizeConfiguration": "Resize widget configuration panel",
  "datox.designer.resizeConfigurationHelp": "Drag to resize the configuration panel. Double-click to reset. Arrow keys adjust the width.",
  "datox.designer.formulaCalculation": "Calculation",
  "datox.designer.formulaColumnMode": "Column aggregation",
  "datox.designer.formulaStartingPoint": "Choose a starting point",
  "datox.designer.formulaTemplates": "Templates",
  "datox.designer.formulaRatio": "Ratio",
  "datox.designer.formulaRatioHint": "A ÷ B, safely",
  "datox.designer.formulaPercentOf": "% of",
  "datox.designer.formulaPercentHint": "A as a percentage of B",
  "datox.designer.formulaDifference": "Difference",
  "datox.designer.formulaDifferenceHint": "A minus B",
  "datox.designer.formulaFlag": "Conditional flag",
  "datox.designer.formulaFlagHint": "If A exceeds a limit: 1, else 0",
  "datox.designer.formulaStartBlank": "Start blank",
  "datox.designer.formulaNameKpi": "Name KPI from formula",
  "datox.designer.formulaUndo": "Undo formula",
  "datox.designer.formulaRedo": "Redo formula",
  "datox.designer.formulaUndoTemplate": "Undo template",
  "datox.designer.formulaEditExpression": "Edit expression",
  "datox.designer.formulaBackToBuilder": "Back to builder",
  "datox.designer.formulaWorkspace": "Formula workspace",
  "datox.designer.formulaBuilderHint": "Click a value or operator to edit it, or use Edit to replace a formula term.",
  "datox.designer.formulaPreserved": "Your expression is preserved.",
  "datox.designer.formulaTemplateReady": "Template ready. Choose your columns.",
  "datox.designer.formulaReplaced": "Calculation replaced.",
  "datox.designer.formulaDisplay": "Display",
  "datox.designer.formulaPreviewHint": "Preview the calculation before applying it.",
  "datox.designer.formulaEditTerm": "Change, insert, or remove this formula term",
  "datox.designer.formulaEdit": "Edit",
  "datox.designer.formulaInsert": "Add an operation or insert a function",
  "datox.designer.formulaAddTo": "Add to formula",
  "datox.designer.formulaOperationHeading": "Operation on this result",
  "datox.designer.formulaFunctionHeading": "Function or condition",
  "datox.designer.formulaChangeTerm": "Change this term",
  "datox.designer.formulaOperation": "Formula operation",
  "datox.designer.formulaAggregation": "Formula aggregation",
  "datox.designer.formulaAdd": "Add (+)",
  "datox.designer.formulaSubtract": "Subtract (−)",
  "datox.designer.formulaMultiply": "Multiply (×)",
  "datox.designer.formulaDivide": "Divide (÷)",
  "datox.designer.formulaGreater": "Greater than",
  "datox.designer.formulaGreaterEqual": "Greater than or equal",
  "datox.designer.formulaLess": "Less than",
  "datox.designer.formulaLessEqual": "Less than or equal",
  "datox.designer.formulaEqual": "Equal to",
  "datox.designer.formulaNotEqual": "Not equal to",
  "datox.designer.formulaSum": "Sum",
  "datox.designer.formulaAverage": "Average",
  "datox.designer.formulaMinimum": "Minimum",
  "datox.designer.formulaMaximum": "Maximum",
  "datox.designer.formulaCountRows": "Count rows",
  "datox.designer.formulaOf": "of",
  "datox.designer.formulaAggregatePhrase": "{aggregate} of {column}",
  "datox.designer.formulaRoundPhrase": "Round {value} to {digits} decimal places",
  "datox.designer.formulaAbsPhrase": "Absolute value of {value}",
  "datox.designer.formulaSourceColumn": "Source column",
  "datox.designer.formulaAggregate": "Aggregate of a column",
  "datox.designer.formulaFixedNumber": "Fixed number",
  "datox.designer.formulaGroup": "Calculation group",
  "datox.designer.formulaLiteral": "Blank / True / False",
  "datox.designer.formulaSafeDivide": "Safe division",
  "datox.designer.formulaConditional": "If / Then / Otherwise",
  "datox.designer.formulaComparison": "Comparison",
  "datox.designer.formulaLogic": "AND / OR conditions",
  "datox.designer.formulaNot": "NOT condition",
  "datox.designer.formulaRound": "Round",
  "datox.designer.formulaAbsolute": "Absolute value",
  "datox.designer.formulaNegate": "Negate value",
  "datox.designer.formulaRemoveSign": "Remove sign",
  "datox.designer.formulaRemoveFunction": "Remove function",
  "datox.designer.formulaRemoveTerm": "Remove this term",
  "datox.designer.formulaEditNumber": "Edit number",
  "datox.designer.formulaEnterNumber": "Enter a number",
  "datox.designer.formulaBlank": "Blank",
  "datox.designer.formulaWhen": "When",
  "datox.designer.formulaThen": "Then return",
  "datox.designer.formulaOtherwise": "Otherwise",
  "datox.designer.formulaAddCondition": "Add condition",
  "datox.designer.formulaAll": "All (AND)",
  "datox.designer.formulaAny": "Any (OR)",
  "datox.designer.formulaTo": "to",
  "datox.designer.formulaDecimalPlaces": "decimal places",
  "datox.designer.formulaAdvancedEditor": "Advanced formula editor",
  "datox.designer.formulaAutocompleteHelp": "Ctrl+Space suggests functions and columns. Hover a function for its signature.",
  "datox.designer.formulaEditorUnavailable": "The expression editor could not load. You can continue editing the expression below.",
  "datox.designer.formulaHelpSum": "sum(column) — Sum of the filtered column.",
  "datox.designer.formulaHelpAvg": "avg(column) — Average of the filtered column.",
  "datox.designer.formulaHelpMin": "min(column) — Minimum value.",
  "datox.designer.formulaHelpMax": "max(column) — Maximum value.",
  "datox.designer.formulaHelpCount": "count() — Number of filtered rows.",
  "datox.designer.formulaHelpDivide": "safe_divide(numerator, denominator) — Returns blank for a zero denominator.",
  "datox.designer.formulaHelpRound": "round(value, decimals) — Round to 0–6 decimal places.",
  "datox.designer.formulaHelpAbs": "abs(value) — Absolute value.",
  "datox.designer.formulaHelpIf": "if_else(condition, then_value, otherwise_value) — Evaluates only the selected branch.",
  "datox.designer.formulaParseEmpty": "Enter a formula.",
  "datox.designer.formulaParseLength": "Formula exceeds 1,000 characters.",
  "datox.designer.formulaParseField": "Choose a valid source column.",
  "datox.designer.formulaParseNumber": "Enter a valid number.",
  "datox.designer.formulaParseAggregate": "Fields must appear inside an aggregate.",
  "datox.designer.formulaParseFunction": "Unsupported formula function.",
  "datox.designer.formulaParseArguments": "Invalid function arguments.",
  "datox.designer.formulaParseComplexity": "Formula exceeds the supported complexity or nesting limit.",
  "datox.designer.formulaParseMultiline": "Wrap multiline calculations in parentheses.",
  "datox.designer.formulaParseComparison": "Chained comparisons are not supported.",
  "datox.designer.formulaParseSyntax": "Check the formula syntax at the highlighted character.",
  "datox.designer.datasetLoadIncomplete": "The dataset could not be loaded completely, changed during loading, or exceeds 100,000 rows. Refresh the dashboard or use a smaller dataset.",
  "datox.designer.kpiFormula": "KPI formula",
  "datox.designer.insertAggregate": "Insert aggregate",
  "datox.designer.ratioFormula": "Build a ratio",
  "datox.designer.conditionalFormula": "Build a condition",
  "datox.designer.formulaExpression": "Formula expression",
  "datox.designer.formulaHelp": "Use sum, avg, min, max, count(), safe_divide, round, abs and if_else. Conditions support and, or, not and numeric comparisons. Quote field names with backticks.",
  "datox.designer.previewFormula": "Preview calculation",
  "datox.designer.useFormula": "Use formula",
  "datox.designer.clearFormula": "Return to column / aggregation",
  "datox.designer.invalidFormula": "The formula could not be evaluated. Check its syntax, source columns and saved dashboard revision.",
  "datox.designer.invalidKpiDisplay": "Saved KPI display settings are invalid or unsupported.",
  "datox.designer.aggregationMedian": "Median",
  "datox.designer.aggregationDistinct": "Distinct count",
  "datox.designer.aggregationStddev": "Standard deviation",
  "datox.designer.aggregationVariance": "Variance",
  "datox.designer.sourceRows": "Source rows",
  "datox.designer.kpiDisplay": "KPI display and target",
  "datox.designer.layout": "Layout",
  "datox.designer.standard": "Standard",
  "datox.designer.compact": "Compact",
  "datox.designer.prominent": "Prominent",
  "datox.designer.inherit": "Use existing format",
  "datox.designer.currency": "Currency",
  "datox.designer.notation": "Number notation",
  "datox.designer.currencyCode": "Currency code",
  "datox.designer.unit": "Unit",
  "datox.designer.prefix": "Prefix",
  "datox.designer.scale": "Display scale",
  "datox.designer.none": "None",
  "datox.designer.thousands": "Thousands",
  "datox.designer.millions": "Millions",
  "datox.designer.billions": "Billions",
  "datox.designer.percentScale": "Percentage source units",
  "datox.designer.percentagePoints": "Percentage points",
  "datox.designer.percentagePointUnit": "pp",
  "datox.designer.ratio": "Ratio (0–1)",
  "datox.designer.target": "Target",
  "datox.designer.targetValue": "Target value in display units",
  "datox.designer.targetVisual": "Target visualization",
  "datox.designer.bar": "Bar",
  "datox.designer.ring": "Ring",
  "datox.designer.kpiComparison": "Previous-period KPI comparison",
  "datox.designer.comparePrevious": "Compare with a published KPI",
  "datox.designer.previousPeriod": "Previous reporting period",
  "datox.designer.previousPeriodShared": "This period link is shared by dashboards in the current reporting period.",
  "datox.designer.previousDashboard": "Previous dashboard",
  "datox.designer.previousKpi": "Previous KPI",
  "datox.designer.chooseSource": "Choose a published source",
  "datox.designer.comparisonVisual": "Comparison visualization",
  "datox.designer.bars": "Bars",
  "datox.designer.slope": "Slope",
  "datox.designer.showChange": "Show change",
  "datox.designer.both": "Amount and percentage",
  "datox.designer.amountChange": "Amount change",
  "datox.designer.percentageChange": "Percentage change",
  "datox.designer.direction": "Favorable direction",
  "datox.designer.higherBetter": "Higher is better",
  "datox.designer.lowerBetter": "Lower is better",
  "datox.designer.neutral": "Neutral",
  "datox.designer.comparisonUnavailable": "Choose an available published KPI from the linked previous period for this client.",
  "datox.designer.loadingComparison": "Loading comparison…",
  "datox.designer.previousValue": "Previous",
  "datox.designer.currentValue": "Current",
  "datox.designer.republishPrevious": "The previous KPI has no saved numeric value. Load it and republish that dashboard.",
  "datox.designer.advancedTable": "Advanced table settings",
  "datox.designer.tableDisplay": "Display",
  "datox.designer.filledHeader": "Filled header (accent bar)",
  "datox.designer.tableHeaderColor": "Header color",
  "datox.designer.tableHeaderColorHint": "Leave empty to use the dashboard accent color.",
  "datox.designer.dashboardAccent": "Dashboard accent",
  "datox.designer.dashboardPalette": "Dashboard palette",
  "datox.designer.chartDefault": "Chart default",
  "datox.designer.clearColor": "Clear color override",
  "datox.designer.rowDensity": "Row density",
  "datox.designer.comfortable": "Comfortable",
  "datox.designer.spacious": "Spacious",
  "datox.designer.alternatingRows": "Alternating row shading",
  "datox.designer.enablePagination": "Enable pagination",
  "datox.designer.pagination": "Paginate rows",
  "datox.designer.rowsPerPage": "Rows per page",
  "datox.designer.summaryRow": "Show summary row",
  "datox.designer.tableSummary": "Summary",
  "datox.designer.columnLabel": "Display label",
  "datox.designer.auto": "Automatic",
  "datox.designer.summaryOperation": "Summary operation",
  "datox.designer.conditionalColors": "Conditional cell and row colors",
  "datox.designer.condition": "Condition",
  "datox.designer.color": "Color",
  "datox.designer.highlightWholeRow": "Highlight the entire row",
  "datox.designer.addColorRule": "Add color rule",
  "datox.designer.editableTable": "Editable table cells",
  "datox.designer.materializeTable": "Create an editable copy",
  "datox.designer.materializeTableHint": "This table is connected to a dataset. Create an independent editable copy of up to 50 rows and 20 columns to use cell and merge controls.",
  "datox.designer.addRow": "Add row",
  "datox.designer.addColumn": "Add column",
  "datox.designer.highlightHeader": "Highlight header row",
  "datox.designer.rowNumbers": "Show row numbers",
  "datox.designer.columnType": "Column type",
  "datox.designer.date": "Date",
  "datox.designer.deleteColumn": "Delete column",
  "datox.designer.deleteRow": "Delete row",
  "datox.designer.rowType": "Row type",
  "datox.designer.sectionRow": "Section heading",
  "datox.designer.cellValue": "Cell value",
  "datox.designer.row": "Row",
  "datox.designer.mergeSpan": "Columns to merge",
  "datox.designer.mergeCells": "Merge cells",
  "datox.designer.unmergeCells": "Unmerge cells",
  "datox.designer.invalidMerge": "Choose adjacent cells inside one row that do not overlap an existing merge.",
  "datox.designer.advancedChart": "Advanced chart settings",
  "datox.designer.chartSection": "Chart",
  "datox.designer.barStyle": "Bar style",
  "datox.designer.rounded": "Rounded",
  "datox.designer.gradient": "Gradient",
  "datox.designer.horizontalBarHint": "Horizontal bars follow the category axis.",
  "datox.designer.barColors": "Bar colors",
  "datox.designer.primaryBarColor": "Primary bar color",
  "datox.designer.primaryBarColorHint": "Leave empty to use the dashboard accent color.",
  "datox.designer.highlightCategory": "Highlight category (optional)",
  "datox.designer.highlightCategoryHint": "Match the exact category value; suggestions come from sample rows.",
  "datox.designer.fillArea": "Fill area under line",
  "datox.designer.fillAreaUnder": "Fill area under",
  "datox.designer.fillAreaUnderHint": "Series drawn as a filled area (none by default).",
  "datox.designer.lineAppearance": "Line appearance",
  "datox.designer.lineThickness": "Line thickness",
  "datox.designer.linePattern": "Line pattern",
  "datox.designer.pointMarkers": "Point markers",
  "datox.designer.pointMarkersHint": "Automatic hides markers on dense charts.",
  "datox.designer.show": "Show",
  "datox.designer.hide": "Hide",
  "datox.designer.lineColor": "Line color",
  "datox.designer.lineColorHint": "Leave empty to use the chart default.",
  "datox.designer.seriesColors": "Series colors",
  "datox.designer.seriesColorsHint": "Leave empty to use the dashboard palette.",
  "datox.designer.scatterX": "X-axis numeric column",
  "datox.designer.scatterY": "Y-axis numeric column",
  "datox.designer.bubbleSize": "Bubble size column",
  "datox.designer.seriesLabel": "Series label",
  "datox.designer.seriesType": "Series type",
  "datox.designer.line": "Line",
  "datox.designer.area": "Area",
  "datox.designer.secondaryAxis": "Use secondary value axis",
  "datox.designer.secondaryAxisLabel": "Secondary axis label",
  "datox.designer.lineStyle": "Line style",
  "datox.designer.solid": "Solid",
  "datox.designer.dashed": "Dashed",
  "datox.designer.dotted": "Dotted",
  "datox.designer.lineWidth": "Line width",
  "datox.designer.smoothLines": "Smooth lines",
  "datox.designer.showMarkers": "Show markers",
  "datox.designer.markerSize": "Marker size",
  "datox.designer.axisRotation": "Axis label rotation",
  "datox.designer.startFromZero": "Include zero on value axes",
  "datox.designer.barWidth": "Maximum bar width (px)",
  "datox.designer.barCategoryGap": "Space between categories (%)",
  "datox.designer.barCornerRadius": "Bar corner radius (px)",
  "datox.designer.previousPage": "Previous page",
  "datox.designer.nextPage": "Next page",
  "datox.designer.dashboardCanvas": "Dashboard canvas",
  "datox.designer.snapToGuides": "Snap to grid and guides",
  "datox.designer.canvasShortcuts": "Hold Alt to bypass snapping. Shift/Ctrl/Cmd-click or drag on empty canvas to select multiple widgets. Arrow keys move the selection; Shift moves in larger steps.",
  "datox.designer.multipleSelection": "Multiple widgets selected",
  "datox.designer.selectedWidgets": "Selected widgets",
  "datox.designer.selectAllWidgets": "Select all widgets",
  "datox.designer.copySelection": "Copy widgets",
  "datox.designer.pasteSelection": "Paste widgets",
  "datox.designer.duplicateSelection": "Duplicate selection",
  "datox.designer.deleteSelection": "Delete selection",
  "datox.designer.pasteScope": "Paste copied widgets within this dashboard",
  "datox.designer.pasteDoesNotFit": "The copied selection is larger than this page. Resize it or enlarge the page before pasting.",
  "datox.designer.overlapDuringMove": "Widgets overlap. Move to an empty area before releasing.",
  "datox.designer.overlapReverted": "That placement overlaps another widget. The original position and size were restored.",
  "datox.designer.placementOverlap": "That placement overlaps another widget. Choose an empty area to add it.",
  "datox.designer.noFreePlacement": "The selection could not be placed without overlap. Enlarge the canvas or choose another page.",
  "datox.dashboardAgent.title": "Dashboard assistant",
  "datox.dashboardAgent.hint": "Ask a question or describe a dashboard change. Suggested edits can be applied or discarded here.",
  "datox.dashboardAgent.prompt": "Ask about this dashboard or describe a change…",
  "datox.dashboardAgent.page": "Working with the current page",
  "datox.dashboardAgent.limit": "Select a widget to narrow the request to 20 widgets or fewer.",
  "datox.dashboardAgent.waitForSave": "Finish saving your changes before using the dashboard assistant.",
  "datox.dashboardAgent.thinking": "Dashboard agent is preparing a response…",
  "datox.dashboardAgent.error": "The dashboard agent could not complete this request. Your saved dashboard has not been replaced.",
  "datox.dashboardAgent.applyError": "The result of applying this proposal could not be confirmed. Refresh or retry Apply to check its saved status.",
  "datox.dashboardAgent.stale": "The dashboard or its data changed. Request a new proposal.",
  "datox.dashboardAgent.apply": "Apply suggested changes",
  "datox.dashboardAgent.applying": "Applying changes…",
  "datox.dashboardAgent.discard": "Discard suggestion",
  "datox.dashboardAgent.resizeAssistant": "Resize dashboard assistant panel",
  "datox.dashboardAgent.settings": "Proposed widget settings",
  "datox.dashboardAgent.suggestions": "Suggested changes",
  "datox.dashboardAgent.actionDetails": "View action details",
  "datox.dashboardAgent.action.createTab": "Create tab: {{name}}",
  "datox.dashboardAgent.action.renameTab": "Rename {{current}} to {{name}}",
  "datox.dashboardAgent.action.deleteTab": "Remove tab: {{name}} and all its widgets ({{count}})",
  "datox.dashboardAgent.action.addWidget": "Add {{name}} to {{tab}}",
  "datox.dashboardAgent.action.updateWidget": "Update widget: {{name}}",
  "datox.dashboardAgent.action.moveWidget": "Move widget: {{name}}",
  "datox.dashboardAgent.action.moveWidgetToTab": "Move {{name}} to {{tab}}",
  "datox.dashboardAgent.action.resizeWidget": "Resize widget: {{name}}",
  "datox.dashboardAgent.action.duplicateWidget": "Duplicate widget: {{name}}",
  "datox.dashboardAgent.action.deleteWidget": "Remove widget: {{name}}",
  "datox.dashboardAgent.pending": "Ready to review",
  "datox.dashboardAgent.applied": "Changes applied",
  "datox.dashboardAgent.discarded": "Proposal discarded",
  "datox.dashboardAgent.expired": "Proposal expired. Request a new proposal.",
  "datox.dashboardAgent.clarification": "More information needed",
  "datox.dashboardAgent.blocked": "This change is not currently supported",
  "datox.dashboardAgent.you": "You",
  "datox.dashboardAgent.widgetSearchHint": "Type # to reference a widget on any page.",
  "datox.dashboardAgent.widgetSearch": "Search dashboard widgets",
  "datox.dashboardAgent.noWidgets": "No matching widgets.",
  "datox.dashboardAgent.removeReference": "Remove reference to {{name}}",
  "datox.dashboardAgent.referenceStale": "A referenced widget was moved or removed. Remove its reference and select it again.",
  "datox.designer.explainSource": "Explain source",
  "datox.source.title": "Explain source",
  "datox.source.drilldown": "Source explorer",
  "datox.source.rows": "Filtered rows",
  "datox.source.filesShort": "Source files",
  "datox.source.fields": "Fields",
  "datox.source.result": "Calculated value",
  "datox.source.expression": "View original expression",
  "datox.source.citations": "Evidence locations · {{count}}",
  "datox.source.backToSource": "Back to source",
  "datox.source.widgetId": "Widget ID",
  "datox.source.datasetId": "Dataset ID",
  "datox.source.loading": "Loading saved source evidence…",
  "datox.source.failed": "Source evidence could not be loaded. The dashboard may have changed; refresh and try again.",
  "datox.source.revision": "Saved revision {{revision}}",
  "datox.source.calculation": "Calculation",
  "datox.source.dataset": "Saved dataset",
  "datox.source.rowCount": "Rows after saved filters: {{count}} (bounded preview below)",
  "datox.source.binding": "Widget binding and filters",
  "datox.source.lineage": "Source lineage",
  "datox.source.steps": "Transformation steps",
  "datox.source.files": "Extracted source files",
  "datox.source.noFiles": "No verified source file is available for this saved widget.",
  "datox.source.unknownFile": "Unidentified source file",
  "datox.source.openFile": "Open source file",
  "datox.source.openEvidence": "Open cited location",
  "datox.source.page": "Page {{page}}",
  "datox.source.row": "Row {{row}}",
  "datox.source.extractedRows": "Extracted rows (bounded preview)",
  "datox.source.aiSummary": "Optional AI explanation",
  "datox.source.aiUnavailable": "An AI explanation is unavailable. Saved facts above remain available.",
  "datox.source.explainWithAi": "Explain with AI",
  "datox.source.aiLoading": "Preparing AI explanation…",
  "datox.source.closeFile": "Close source file",
  "datox.source.loadingFile": "Loading authorized source file…",
  "datox.source.fileUnavailable": "This source file cannot be previewed here. You may be able to download it.",
  "datox.source.sheet": "Worksheet",
  "datox.source.goToRow": "Go to row",
  "datox.source.sheetWindow": "A bounded window around the cited row and column is shown; highlighted cells mark the cited range.",
  "datox.source.downloadFile": "Download source file",
  "datox.designer.reports": "Reports",
  "datox.designer.workspaceTools": "Workspace tools",
  "datox.designer.workflowFiles": "Open Workflow files",
  "datox.designer.existingChat": "Conversation",
  "datox.designer.refreshChat": "Refresh conversation",
  "datox.designer.processingChat": "Workflow processing chat",
  "datox.designer.processingChatHint": "Messages here go to the agent running this report. New chats are unavailable until the workflow stops.",
  "datox.designer.processingChatWaiting": "Waiting for the workflow agent to connect…",
  "datox.designer.processingChatPaused": "The workflow is not currently running. Resume it from Workflow to continue messaging the agent.",
  "datox.designer.processingChatFinished": "This workflow has finished. Start a new report chat or choose an existing conversation to continue.",
  "datox.designer.newChatWhileRunning": "New chats are unavailable while this report's workflow is active.",
  "datox.designer.chatActionRequired": "The agent needs your input. Open this chat to answer its question or review the requested action.",
  "datox.designer.dataSettings": "Data settings",
  "datox.designer.designSettings": "Design settings",
  "datox.designer.tidyLayout": "Arrange page",
  "datox.designer.position": "Position and size",
  "datox.designer.chooseColumn": "Choose a column",
  "datox.designer.removeLogo": "Remove logo",
  "datox.designer.editor": "Editor",
  "datox.designer.workflow": "Workflow",
  "datox.designer.assistant": "Assistant",
  "datox.designer.templates": "Templates",
  "datox.designer.elements": "Elements",
  "datox.designer.text": "Text",
  "datox.designer.brand": "Brand",
  "datox.designer.uploads": "Uploads",
  "datox.designer.data": "Data",
  "datox.designer.properties": "Properties",
  "datox.designer.preview": "Preview",
  "datox.designer.export": "Export",
  "datox.designer.share": "Share",
  "datox.designer.settings": "Report settings",
  "datox.designer.portfolios": "Portfolios",
  "datox.designer.sourceFilter": "Source filter (optional)",
  "datox.designer.removePortfolio": "Remove {{name}}",
  "datox.designer.remove": "Remove",
  "datox.designer.closePanel": "Close panel",
  "datox.designer.openPanel": "Open tools",
  "datox.designer.back": "Back to reports",
  "datox.designer.recent": "Your reports",
  "datox.designer.startBlank": "Start from scratch",
  "datox.designer.blankHint": "Create a report with your own layout.",
  "datox.designer.factsheetHint": "Portfolio performance, NAV, allocation and holdings.",
  "datox.designer.allReports": "All reports",
  "datox.designer.assistantHello": "Report assistant",
  "datox.designer.assistantHint": "Use your existing conversation to work with files, calculations and report layouts.",
  "datox.designer.prompt": "Ask a question or describe a change…",
  "datox.designer.send": "Send message",
  "datox.designer.buildPrompt": "Help me populate this report from my connected files. Explain any missing inputs before proceeding.",
  "datox.designer.explainPrompt": "Explain the selected visualization using its saved data and calculation sources.",
  "datox.designer.reviewPrompt": "Review this report for missing data and explain what I need to complete it.",
  "datox.designer.buildAction": "Help me build this report",
  "datox.designer.reviewAction": "Check my report data",
  "datox.designer.explainAction": "Explain this visualization",
  "datox.designer.askAbout": "Ask about this",
  "datox.designer.viewData": "View underlying data",
  "datox.designer.viewCalculation": "View calculation in Workflow",
  "datox.designer.context": "Working with: {{name}}",
  "datox.designer.thinking": "Agent is working…",
  "datox.designer.toolWorking": "Using {{tool}}",
  "datox.designer.chatError": "The conversation could not be completed. Open chat history to check the latest response before sending again.",
  "datox.designer.chatLoadingError": "Chat history could not be loaded. Refresh to try again.",
  "datox.designer.history": "Conversation history",
  "datox.designer.newChat": "New conversation",
  "datox.designer.reportChat": "{{name}} — report conversation",
  "datox.designer.connectFirst": "Choose a reporting period in report settings to start a conversation.",
  "datox.designer.addPage": "Add page",
  "datox.designer.addTemplate": "Add page: {name}",
  "datox.designer.pageActions": "Page actions",
  "datox.designer.renamePageAction": "Rename",
  "datox.designer.duplicatePage": "Duplicate page",
  "datox.designer.deletePage": "Delete page",
  "datox.designer.pageName": "Page {{number}}",
  "datox.designer.pageCount": "{{current}} / {{total}}",
  "datox.designer.pages": "Pages",
  "datox.designer.fit": "Fit",
  "datox.designer.zoom": "Zoom",
  "datox.designer.undo": "Undo",
  "datox.designer.redo": "Redo",
  "datox.designer.duplicate": "Duplicate",
  "datox.designer.delete": "Delete",
  "datox.designer.moveUp": "Move page earlier",
  "datox.designer.moveDown": "Move page later",
  "datox.designer.renamePage": "Page name",
  "datox.designer.elementsHint": "Add a visualization, then connect it to your report data.",
  "datox.designer.textHint": "Add headings, commentary and disclosures.",
  "datox.designer.brandHint": "A consistent look across every page.",
  "datox.designer.templateHint": "Add a designed page. Your existing pages stay in place.",
  "datox.designer.layoutOverview": "Executive overview",
  "datox.designer.layoutAnalysis": "Visual analysis",
  "datox.designer.layoutDetail": "Detailed table",
  "datox.designer.accent": "Accent color",
  "datox.designer.headerColor": "Heading color",
  "datox.designer.font": "Font",
  "datox.designer.logo": "Brand logo",
  "datox.designer.useLogo": "Apply logo to page headers",
  "datox.designer.logoHint": "Upload a PNG, JPEG or WebP image (up to 2 MB).",
  "datox.designer.logoError": "Choose a PNG, JPEG or WebP image smaller than 2 MB.",
  "datox.designer.dataset": "Data source",
  "datox.designer.metric": "Value column",
  "datox.designer.dimension": "Label column",
  "datox.designer.aggregation": "Calculation",
  "datox.designer.noDataset": "Not connected",
  "datox.designer.noSelection": "Select an element on the page to edit it.",
  "datox.designer.title": "Title",
  "datox.designer.content": "Content",
  "datox.designer.width": "Width",
  "datox.designer.height": "Height",
  "datox.designer.positionX": "Horizontal position",
  "datox.designer.positionY": "Vertical position",
  "datox.designer.appearance": "Appearance",
  "datox.designer.pageSize": "Page size",
  "datox.designer.landscape": "Landscape",
  "datox.designer.portrait": "Portrait",
  "datox.designer.emptyCanvas": "Empty report page",
  "datox.designer.emptyCanvasHint": "Choose a template, add an element, or ask your assistant.",
  "datox.designer.workflowHint": "Workflow details for this project and reporting period. Outputs may include other reports in the same period.",
  "datox.designer.returnEditor": "Return to editor",
  "datox.designer.saving": "Saving…",
  "datox.designer.saved": "All changes saved",
  "datox.designer.unsaved": "Unsaved changes",
  "datox.designer.saveError": "Your changes could not be saved.",
  "datox.designer.retry": "Retry",
  "datox.designer.refreshData": "Refresh data",
  "datox.designer.previewHint": "Interactive preview · use filters to explore your report",
  "datox.designer.exitPreview": "Back to editing",
  "datox.designer.exportHint": "Export a saved snapshot. Long tables continue onto additional pages.",
  "datox.designer.exporting": "Preparing PDF…",
  "datox.designer.readOnly": "View only",
  "datox.designer.unsavedLeave": "Your report has unsaved changes. Leave this page?",
} as const

export const REPORT_STUDIO_ENGLISH = {
  ...REPORT_DESIGNER_ENGLISH,
  "datox.report.actions": "Report actions",
  "datox.report.delete": "Delete report",
  "datox.report.deleting": "Deleting…",
  "datox.report.deleteWorkspaceConfirm": "Delete “{{name}}” from Reports? The report will be archived. Source files and conversations are kept.",
  "datox.report.deleteConfirm": "Delete “{{name}}”? Source files and conversations are kept.",
  "datox.report.deleteFailed": "The report could not be deleted. Refresh and try again.",
  "datox.report.deleteConflict": "The report has changed or a run is active. Refresh the report and finish or cancel its active run before deleting.",
  "datox.report.historyArtifacts": "Historical reports",
  "datox.report.definitionHistory": "Category definition history",
  "datox.report.restoreDefinition": "Load this definition into draft",
  "datox.report.adoptCategories": "Import historical categories",
  "datox.report.adoptHint": "Select a saved extraction to preview its categories. Imported categories are copied into your draft; historical evidence stays unchanged.",
  "datox.report.addTarget": "Add portfolio target",
  "datox.report.removeTarget": "Remove target from this report",
  "datox.report.targetName": "Portfolio {{number}}",
  "datox.report.benchmark": "Benchmark",
  "datox.report.upgradeTemplate": "Add missing factsheet sections",
  "datox.report.upgradeHint": "Add the missing sections from the four-page template. Existing widgets and their data bindings are preserved in a new revision.",
  "datox.report.duplicate": "Duplicate report",
  "datox.report.copyName": "{{name}} — copy",
  "datox.report.archiveConfirm": "Archive this report? Its saved outputs and history are retained.",
  "datox.report.exportPages": "Pages to export",
  "datox.report.workflow.started": "Report workflow started",
  "datox.report.workflow.conflict": "The report or its workflow changed. Refresh Workflow and try again.",
  "datox.report.workflow.automationFirst": "Run this report successfully once before configuring an automation.",
  "datox.report.exportIntro": "Choose which report pages to include in your PDF.",
  "datox.report.exportSelectAll": "Select all",
  "datox.report.exportClearSelection": "Clear selection",
  "datox.report.exportSelectionSummary": "Selected: {{selected}} of {{total}}",
  "datox.report.exportPageNumber": "Page {{number}}",
  "datox.report.exportDetails": "Export details",
  "datox.report.exportPreparing": "Preparing PDF…",
  "datox.report.exportPreparingHint": "Keep this window open. Your download will start when the PDF is ready.",
  "datox.report.exportEmptySelection": "Select at least one page to continue.",
  "datox.report.exportCurrent": "Export current version",
  "datox.report.downloadLatest": "Download latest export",
  "datox.report.exportScope": "Client: {{client}} · Reporting date: {{date}} · Version {{version}}",
  "datox.report.report": "Report",
  "datox.report.overview": "Overview",
  "datox.report.new": "New report",
  "datox.report.untitled": "Untitled report",
  "datox.report.untitledFactsheet": "Untitled factsheet",
  "datox.report.createHint": "Start with a designed template or an empty canvas. Connect your data when you're ready.",
  "datox.report.fromTemplate": "From template",
  "datox.report.blank": "Blank report",
  "datox.report.blankHint": "Build your own layout with pages, metrics, charts and tables.",
  "datox.report.templateHint": "A portfolio layout with editable metrics, allocation charts and holdings.",
  "datox.report.useTemplate": "Use template",
  "datox.report.openCanvas": "Open canvas",
  "datox.report.canvas": "Canvas",
  "datox.report.connectData": "Connect data",
  "datox.report.manageData": "Manage data",
  "datox.report.updateData": "Update report data",
  "datox.report.dataHint": "Upload inputs, define your categories and connect the values behind your report.",
  "datox.report.expandData": "Expand data panel",
  "datox.report.closeData": "Close data panel",
  "datox.report.notConnected": "Not connected",
  "datox.report.noValues": "No data available",
  "datox.report.needsData": "Needs data",
  "datox.report.ready": "Ready",
  "datox.report.status": "Status",
  "datox.report.versions": "Version history",
  "datox.report.addWidget": "Add widget",
  "datox.report.fitCanvas": "Fit canvas to width",
  "datox.report.client": "Client",
  "datox.report.allClients": "All clients",
  "datox.report.unassigned": "Unassigned",
  "datox.report.type": "Type",
  "datox.report.custom": "Custom",
  "datox.report.period": "Reporting period",
  "datox.report.asOf": "As-of date",
  "datox.report.choosePeriod": "Choose a reporting period to connect files",
  "datox.report.periodHelp": "Choose or create a reporting period in report settings. Data stays scoped to that reporting period.",
  "datox.report.details": "Report details",
  "datox.report.exportDraft": "DRAFT — report data is incomplete",
  "datox.report.exportFailed": "The report could not be exported. Check that its images and charts are available, then retry.",
  "datox.report.retryExport": "Retry saving export",
  "datox.report.exportSnapshotHint": "Choose the pages to export. The PDF uses a saved version of this report, including its client, period and filters. Long tables continue onto additional pages. Incomplete reports are marked as drafts.",
  "datox.report.exports": "Export history",
  "datox.report.noExports": "Use Export in the dashboard to download a report. No saved exports are available.",
  "datox.report.download": "Download PDF",
  "datox.report.version": "Version {{version}}",
  "datox.report.useNextPeriod": "Use for another period",
  "datox.report.reuseHint": "Keep the layout and category definitions. Start with new inputs for the next reporting date.",
  "datox.report.reportName": "Report name",
  "datox.report.rename": "Rename report",
  "datox.report.search": "Search reports or clients",
  "datox.report.libraryTitle": "Your reports",
  "datox.report.libraryHint": "Every client. Every reporting period. All in one place.",
  "datox.report.emptyTitle": "Create your first report.",
  "datox.report.emptyHint": "Choose a template, connect your data and export a report worth sharing.",
  "datox.report.noMatches": "No reports match these filters.",
  "datox.report.templateType": "Factsheet",
  "datox.report.saveFirst": "Save your report details before updating data.",
  "datox.report.readinessHint": "Connect data to populate the template. You can edit its design now.",
  "datox.report.periodLocked": "Use for another period to preserve this report's existing inputs and results.",
  "datox.report.dataIssues": "Data issues",
  "datox.report.grid.tables": "Tables",
  "datox.report.grid.rows": "Rows",
  "datox.report.grid.columns": "Columns",
  "datox.report.grid.columnCount": "Columns: {{count}}",
  "datox.report.grid.tableNumber": "Table {{number}}",
  "datox.report.grid.search": "Search this table",
  "datox.report.grid.sort": "Sort by {{column}}",
  "datox.report.grid.reset": "Reset view",
  "datox.report.grid.noMatches": "No rows match the current search or client filter.",
  "datox.report.grid.noRows": "This table does not contain rows yet.",
  "datox.report.grid.range": "{{from}}–{{to}} / {{total}}",
  "datox.report.grid.pageSize": "Rows per page",
  "datox.report.grid.previous": "Previous",
  "datox.report.grid.next": "Next",
  "datox.report.grid.openRow": "Row {{number}} details",
  "datox.report.grid.closeRow": "Close details",
  "datox.report.run": "Run workflow",
  "datox.report.saveAndRun": "Save & run workflow",
  "datox.report.running": "Workflow running",
  "datox.report.runStarting": "Starting workflow…",
  "datox.report.runHint": "Extract data from your selected files, apply calculations and update the report dashboard.",
  "datox.report.runReady": "Ready to run",
  "datox.report.runSetup": "Complete setup to run",
  "datox.report.viewRun": "View run progress",
  "datox.report.runSaved": "Your changes will be saved before the workflow starts.",
  "datox.report.runReadOnly": "You have view-only access to this report.",
  "datox.report.runRequirements.loading": "Loading report settings…",
  "datox.report.runRequirements.period": "Choose a reporting period",
  "datox.report.runRequirements.date": "Set the as-of date",
  "datox.report.runRequirements.files": "Upload or select input files",
  "datox.report.runRequirements.categories": "Create a category",
  "datox.report.runRequirements.fields": "Give each category a name and at least one named field",
  "datox.report.runRequirements.targets": "Add a named portfolio target",
  "datox.report.approvals": "Approval & sharing",
  "datox.report.share": "Share report",
  "datox.report.shareHint": "Request review or share the saved dashboard with reviewers. A new sharing request publishes the saved dashboard using the existing sharing flow.",
  "datox.report.currentPeriod": "Current period",
  "datox.report.currentPeriodHint": "This period already has report inputs or results. Its data and history stay together.",
  "datox.report.prepareNextPeriod": "Prepare the next reporting period",
  "datox.report.prepareNextPeriodHint": "Reuse this report's workflow, client setup and dashboard design. Choose or create another period, then add its files.",
  "datox.report.saveAndReuse": "Save and use for another period",
  "datox.report.saveBeforeReuseHint": "Your settings changes will be saved before continuing.",
  "datox.report.reuseSource": "Source report",
  "datox.report.reuseSourceUnavailable": "The source report could not be loaded. Refresh to try again.",
  "datox.report.reuseSourcePeriod": "Current period: {{period}}",
  "datox.report.chooseNextPeriod": "Choose another reporting period",
  "datox.report.dashboardShare.title": "Share dashboard",
  "datox.report.dashboardShare.heading": "Dashboard review",
  "datox.report.dashboardShare.description": "Share the selected client's saved dashboard and track reviewer decisions.",
  "datox.report.dashboardShare.option": "{{name}} · Current saved dashboard",
  "datox.report.dashboardShare.picker": "Dashboard",
  "datox.report.dashboardShare.view": "View shared dashboard",
  "datox.report.dashboardShare.ready": "Saved dashboard ready",
  "datox.report.dashboardShare.scoped": "For the selected dashboard",
  "datox.report.dashboardShare.noReviewersHint": "Add reviewer emails to send the first review request for this dashboard.",
  "datox.report.dashboardShare.requestTitle": "Request dashboard review",
  "datox.report.dashboardShare.requestDescription": "Send reviewers a link to the saved dashboard and record their decisions.",
  "datox.report.dashboardShare.emptyTitle": "No dashboard review snapshot available",
  "datox.report.dashboardShare.emptyHint": "A shared dashboard snapshot will appear here after review is requested.",
  "datox.report.dashboardShare.back": "Return to dashboard",
  "datox.report.shareCurrent": "Current saved report",
  "datox.report.shareReload": "Refresh review status",
  "datox.report.shareError": "The report's approval data could not be loaded. Please try again.",
  "datox.report.shareUnavailable": "Open or create the report dashboard before sharing it.",
  "datox.report.extractions": "Extractions",
  "datox.report.transformations": "Transformations",
  "datox.report.outputData": "Output data",
  "datox.report.extractionsHint": "Inspect the raw tables extracted from this report's input files.",
  "datox.report.transformationsHint": "Review calculation instructions, processing steps and source extractions.",
  "datox.report.outputHint": "Browse the saved output tables used by the dashboard.",
  "datox.report.chooseExtraction": "Extraction result",
  "datox.report.chooseTransformation": "Transformation result",
  "datox.report.extraction": "Extraction",
  "datox.report.transformation": "Transformation",
  "datox.report.sourceFile": "Source file",
  "datox.report.sourceExtractions": "Source extractions",
  "datox.report.transformationInstructions": "Instructions",
  "datox.report.transformationSteps": "Processing steps",
  "datox.report.transformationSummary": "Summary",
  "datox.report.noExtractions": "No extraction results yet. Add input files and run extraction from Data.",
  "datox.report.noTransformations": "No transformation results yet. Process the report's input data to create them.",
  "datox.report.noOutputData": "This result does not contain output tables yet.",
  "datox.report.noSteps": "No processing steps were recorded for this result.",
  "datox.report.extractionNumber": "Extraction {{number}}",
  "datox.report.stepNumber": "Step {{number}}",
  "datox.report.rowCount": "Rows: {{count}}",
  "datox.report.openReport": "Open report",
  "datox.report.namePlaceholder": "For example, September portfolio review",
} as const
